// extracted by mini-css-extract-plugin
module.exports = {"tooltipContainer":"Tooltip_tooltipContainer__3mGT5","icon":"Tooltip_icon__9wopJ","tooltipText":"Tooltip_tooltipText__9QAYC"};